module.exports = __webpack_public_path__ + "img/comment-regular.63f97571.svg";